import React, { useState, useEffect, ChangeEvent } from 'react';
import { Button } from 'antd';
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { showSuccessNotification, showErrorNotification } from 'src/util/notifications';
import { uploadToVendorPO } from './actions';
import { REDUCER_KEY } from './reducer';

const UploadToFtpFolder: React.FC = () => {
  const [searchParams] = useSearchParams();
  const vendor = searchParams.get("vendor");
  const dispatch = useDispatch();
  const ftpFileTransfer = useSelector((state: any) => state[REDUCER_KEY]);
  const [loading, setLoading] = useState(false);
  const [moved, setMoved] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  useEffect(() => {
    if (loading) {
      if (ftpFileTransfer && ftpFileTransfer.error) {
        setLoading(false);
        showErrorNotification(ftpFileTransfer.error);
      } else if (!ftpFileTransfer.loading && ftpFileTransfer.data) {
        setLoading(false);
        setMoved(true);
        showSuccessNotification('File uploaded successfully!');
      }
    }
  }, [ftpFileTransfer, loading]);


  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUploadFile = () => {
    if (!selectedFile) {
      showErrorNotification('Please select a file to upload.');
      return;
    }
    setLoading(true);
    dispatch(
      uploadToVendorPO({
        VendorName: vendor,
        file: selectedFile,
      })
    );
  };

  return (
    <div style={{ padding: 24 }}>
      <h4>Upload File to Ftp Folder</h4>
      <p>Vendor: {vendor}</p>
      <input type="file" onChange={handleFileChange} disabled={loading || moved} />
      {selectedFile && <p>Selected File: {selectedFile.name}</p>}
      <Button type="primary" onClick={handleUploadFile} loading={loading} disabled={moved || !selectedFile} style={{ marginTop: 16 }}>
        Upload To VendorPO
      </Button>
    </div>
  );
};

export default UploadToFtpFolder;
